import { OrderStatus, type OrderListReq } from '@ahm/api-wrappers-core';
import { useAuth } from '@ahm/react-auth';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useGetOrderList } from './use-get-order-list';

export function useCountCancelledOrdersToday(currentOrderStatus?: string) {
  const { session } = useAuth();

  const shouldSkipCount = currentOrderStatus === OrderStatus.Assigning;
  const startOfDay = dayjs().startOf('date');
  const endOfDay = dayjs().endOf('date');

  const params: OrderListReq = useMemo(
    () => ({
      status: OrderStatus.Cancelled,
      from_time: startOfDay.unix(),
      to_time: endOfDay.unix(),
      count: 100,
    }),
    [startOfDay, endOfDay]
  );

  const {
    data: orderList,
    isLoading,
    error,
  } = useGetOrderList(params, {
    enabled: !shouldSkipCount && !!session?.token,
  });

  const cancelledOrdersCount = useMemo(() => {
    if (shouldSkipCount) {
      return 0;
    }

    if (!orderList || !session?.user) {
      return 0;
    }

    const orders = Array.isArray(orderList)
      ? orderList
      : (orderList as any).order || (orderList as any).orders || [];

    const cancelledByUser = orders.filter((order: any) => {
      return (
        order.cancel_by_user === true && order.user_id === session.user?._id
      );
    });

    return cancelledByUser.length;
  }, [orderList, session?.user, shouldSkipCount]);

  return {
    count: cancelledOrdersCount,
    isLoading,
    error,
  };
}
